import { render, staticRenderFns } from "./StorageRoomShipmentRuleTable.vue?vue&type=template&id=2f89324f"
import script from "./StorageRoomShipmentRuleTable.vue?vue&type=script&lang=js"
export * from "./StorageRoomShipmentRuleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports